module.exports = __webpack_public_path__ + "static/media/seed0104.99debde6.png";